export const costs = [
  'Information scattered across manuals, forums and videos',
  'Diagnosing by trial and error instead of by readings',
  'Callbacks, wasted refrigerant and parts replaced for nothing',
  'Slower career growth in a trade that is in demand worldwide',
];
